<section class="section-ancrage" [class.onLanding]="onLanding">
  <div class="container--landing">
    <div
      class="landing-subtitle-centered text-40 md:text-46 mb-16 md:mb-44"
      [innerHTML]="'landing.ancrage' | translate"
    ></div>

    <div class="ancrage-image relative shadow px-8 py-12 bg-theme-white max-w-full">
      <div class="font-semibold text-20 mb-8 pr-16">
        {{ 'landing.ancrage_image' | translate : { siteName: languageService.siteName } }}
      </div>
      <img
        src="assets/assets-site/images/illustrations/ancrage-new.png"
        alt=""
        class="ancrage_graph"
      />
      <img
        src="assets/images/landing/icon-ancrage.svg"
        alt=""
        class="absolute -top-16 md:-top-24 -right-16 md:-right-28 w-56 md:w-auto"
      />
    </div>

    <div class="testimony-block">
      <div class="testimony-title" [innerHTML]="'landing.ancrage_text' | translate"></div>

      <ng-container *ngIf="languageService.landingTestimony('ancrage')">
        <div class="testimony-separator"></div>
        <div
          class="testimony-text"
          [innerHTML]="languageService.landingTestimony('ancrage').text"
        ></div>
        <div class="testimony-author">
          <img
            src="assets/assets-site/images/landing/ancrage-author.svg"
            alt=""
            class="testimony-author-icon"
          />
          <div class="testimony-author-content">
            <div class="testimony_author_name">
              {{ languageService.landingTestimony('ancrage').author }}
            </div>
            <div
              class="testimony-author-position"
              *ngIf="languageService.landingTestimony('ancrage').rank"
            >
              {{ languageService.landingTestimony('ancrage').rank }}
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="landing-gradient"></div>
</section>
